/**
 * Validates that bounds is a valid geographic bounds array.
 * A valid bounds array must:
 * - Be an array with exactly 4 elements
 * - Have all values as finite numbers (not null, undefined, NaN, or Infinity)
 * - Have valid geographic ranges (west < east, south < north)
 * @param bounds - Bounds array in format [west, south, east, north] or null/undefined
 * @returns true if bounds is valid, false otherwise
 */
export function isValidBounds(
  bounds: [number, number, number, number] | null | undefined,
): bounds is [number, number, number, number] {
  if (!bounds || !Array.isArray(bounds) || bounds.length !== 4) {
    return false;
  }

  const [west, south, east, north] = bounds;

  // Check all values are finite numbers
  if (
    !Number.isFinite(west) ||
    !Number.isFinite(south) ||
    !Number.isFinite(east) ||
    !Number.isFinite(north)
  ) {
    return false;
  }

  // Check valid geographic ranges
  if (west >= east || south >= north) {
    return false;
  }

  return true;
}
